import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const pwaTitleBarDefaultVariants = {}
const pwaTitleBarCompoundVariants = []

const pwaTitleBarSlotNames = [
  [
    "root",
    "pwaTitleBar__root"
  ],
  [
    "slot",
    "pwaTitleBar__slot"
  ],
  [
    "center",
    "pwaTitleBar__center"
  ],
  [
    "content",
    "pwaTitleBar__content"
  ]
]
const pwaTitleBarSlotFns = /* @__PURE__ */ pwaTitleBarSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, pwaTitleBarDefaultVariants, getSlotCompoundVariant(pwaTitleBarCompoundVariants, slotName))])

const pwaTitleBarFn = memo((props = {}) => {
  return Object.fromEntries(pwaTitleBarSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const pwaTitleBarVariantKeys = [
  "position"
]
const getVariantProps = (variants) => ({ ...pwaTitleBarDefaultVariants, ...compact(variants) })

export const pwaTitleBar = /* @__PURE__ */ Object.assign(pwaTitleBarFn, {
  __recipe__: false,
  __name__: 'pwaTitleBar',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: pwaTitleBarVariantKeys,
  variantMap: {
  "position": [
    "left",
    "right"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, pwaTitleBarVariantKeys)
  },
  getVariantProps
})